import { reactive } from 'vue'
import { state } from './state'
import { HttpClass } from '../shared/http/HttpClass'
import { time } from './time/storeTime'
import { widget } from '../components/widget/store/storeWidget'
import { storeResults } from '../components/ecResults/store/storeResults'

/**
 * APP SETTINGS
 * Anything here will be available to this file only and not exported unless explicitly stated
 */
let appSettings = {
    env: 'process.env.NODE_ENV',
    apiRel: 'api/',
    apiBase: 'process.env.apiBase',
    apiPath: ''
}
appSettings.apiPath = appSettings.apiBase + appSettings.apiRel;

/**
 * Add shared settings to state
 */
state.setAppSettings(appSettings);

// EXPORTING AS REACTIVE "STORE"
export const store = reactive({

    async bootstrapApp() {
        // INIT
        const targetEl = document.querySelector('#'+process.env.APP_TARGET_ID);

        // GET EVENTID AND WIDGETID
        const eventID = targetEl.dataset.ecEventid;
        const widgetID = targetEl.dataset.ecWidgetid;

        // ADD IDs TO STATE
        storeResults.state.setEventID(eventID);
        storeResults.state.setWidgetID(widgetID);

        // GET CURRENT TIME INFORMATION (EXTERNAL)
        const currentTime = await this.updateCurrentTime();
        console.log('currentTime: ', currentTime);

        // GET WIDGET SETTINGS AND SAVE TO STATE
        const widgetSettings = await widget.fetchWidgetSettings();
        widget.state.setWidgetSettings(widgetSettings.data);
        console.log('widgetSettings: ', widgetSettings.data);

        // GET CURRENT WIDGET STEP
        const widgetStep = widget.determineWidgetStep();
    },

    async updateCurrentTime() {
        const currentTime = await this.fetchCurrentTime();
        state.setCurrentTime(currentTime);

        return currentTime;
    },

    async fetchCurrentTime() {
        const http = new HttpClass({
            useCacher: true,
            cacherLabel: 'cfm_ec_current_time',
            cacherUrl: 'https://timeapi.io/api/Time/current/zone?timeZone=US/Eastern',
            cacherForceReload: true,
            cacherTimeout: 1 // minutes
        });

        const cacherUrl = http.buildCacherUrl();

        // MAKE REQUEST
        const res = await http.sendRequest(cacherUrl);

        return res;
    },

    /* Make the follow objects available via the store */
    state,
    time,
    widget,
    storeResults
});